<script>
import { mapGetters, mapActions } from "vuex";

import axios from "axios";

export default {
  computed: {
    ...mapGetters({
      filtro: "filtros/filtro",
      fecha: "filtros/fecha",
    }),
  },
};
</script>

<template>
  <div class="flex flex-col gap-4 text-left">
    <div v-if="filtro.estado == true">
      <h1 class="!text-xl !font-bold">Filtros Dashboard</h1>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="flex flex-row gap-2 items-center">
          <span class="font-bold">Fecha</span>

          <span v-if="fecha == '3'">7 Días</span>
          <span v-if="fecha == '2'">1 mes</span>
          <span v-if="fecha == '1'">1 año</span>
        </div>
        <div class="flex flex-row gap-2 items-center sm:mr-auto">
          <span class="font-bold">
            {{ filtro.text }}
          </span>

          <span>{{ filtro.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
